import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  href?: string;
  size?: 'normal' | 'large';
  className?: string;
}
export function CTAButton({
  text,
  href = '#comprar',
  size = 'normal',
  className = ''
}: CTAButtonProps) {
  const isLarge = size === 'large';
  const isExternal = href.startsWith('http');
  return <motion.a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        inline-flex items-center justify-center gap-2
        bg-terracotta hover:bg-terracotta-hover text-white 
        rounded-full shadow-lg transition-colors duration-300
        font-medium tracking-wide
        ${isLarge ? 'px-8 py-4 text-lg md:text-xl' : 'px-6 py-3 text-base'}
        ${className}
      `} data-id="element-43">
      {text}
      <ArrowRight className={isLarge ? 'w-6 h-6' : 'w-5 h-5'} data-id="element-44" />
    </motion.a>;
}